import Component from 'vue-class-component';
import { _MEETINGS_STORE } from '@/meetings/values/meetings.values';
import {Mixins, Prop, Ref, Watch, Inject} from 'vue-property-decorator';
import { SECTION_TYPE_CODES, RESIZE_TYPES, CLASS_ELEMENTS, SELECTOR_QUERY_ELEMENTS, SKIP_LOADED_PAGE_VERIFICATION_TYPES } from '@/core/values/ed-transparency-meeting.values';
import Course from '@/content/models/course.model';
import { COURSE_EVENTS } from '@/content/values/events';
import { LocalStorageService } from '@/services/local-storage.service';
import WhiteboardMixin from '@/mixins/common/whiteboard.mixin';
import { AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { SECTION_TYPES } from '@/content/values/sections';
import { BOARD_EVENTS } from '@/values/ed-whiteboard.values';
import { SEND_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';
import { LOADING_EVENTS } from '@/core/values/core.values';
import {BoardType} from '@/components/common/ed-board/ed-board.enum';
import EdWhiteboardMenu from '@/core/components/ed-meeting-transparency/ed-whiteboard-menu/ed-whiteboard-menu.component';
import { ConflictResolutionMethod } from '@/components/common/ed-board/ed-board-tools/wbo-client/values/wbo-client.values';
import WboDocument from '@/components/common/ed-board/ed-board-tools/wbo-client/model/wbo-document';
import { WboVersionedAnnotationData } from '@/components/common/ed-board/ed-board-tools/wbo-client/model/wbo-annotation.model';
import WboClient from '@/components/common/ed-board/ed-board-tools/wbo-client/wbo-client';

@Component({})
export default class MeetingTransparencyMixin extends Mixins(WhiteboardMixin) {

    @Inject() EduacAppSetLoading;

    @Prop({default: 0}) public documentIndex : number;
    @Prop({required: false}) public documentHash : string;
    @Prop({required: false}) public internalSection : any;
    @Prop({required: false}) public courseId : number;
    @Ref() readonly boardMenu!: EdWhiteboardMenu;

    public IFRAME_CONTENT : string = 'contentWindow';
    public containerPdfClass : string = 'pdf-container';
    public whiteboardInfo = {};
    public translateTopDefault : number = 40;
    public showMenu : boolean = false;
    public showBoard: boolean = false;
    public elementContainer : any = null;
    public preId: string = 'pdf-';
    private initialBoardName : string = '';

    protected loadedBoardPages      : number[] = [];
    protected initializedBoardPages : number[] = [];
    protected boardPages : any[] = [];
    protected preDocumentId : string = 'pdf-';

    protected boardPage: any = {};

    get meetingId() : number{
        return this.$store.state.MeetingsStore.currentMeetingData.meetingId;
    }

    get whiteboardPathStored() : string {
        return this.$store.state.MeetingsStore.transparentBoardPath;
    }

    get presentationModeViewerType(){
        if (this.areMultiplePresentationModeViewerTypes) {
            return this.multiplePresentationModeViewerTypes[this.documentIndex];
        }
        if(SECTION_TYPES.LESSON_PDF_IMAGE.code === this.$store.state.MeetingsStore.presentationModeViewerType){
            if(this.courses.length > 0 && this.courses[0].viewer.sectionSelected.assetsInfo[0].pdfUrl) {
                return SECTION_TYPE_CODES.LESSON_PDF;
            } else if(this.internalSection && this.internalSection.assetsInfo[0].pdfUrl) {
                return SECTION_TYPE_CODES.LESSON_PDF;
            } else {
                return SECTION_TYPE_CODES.LESSON_IMAGES;
            }
        }
        return this.$store.state.MeetingsStore.presentationModeViewerType == SECTION_TYPES.SUBDECK.code ? SECTION_TYPE_CODES.LESSON_CARD : this.$store.state.MeetingsStore.presentationModeViewerType;
    }

    get multiplePresentationModeViewerTypes(): string[] {
        return this.$store.state.MeetingsStore.multiplePresentationModeViewerTypes;
    }

    get areMultiplePresentationModeViewerTypes(): boolean {
        return this.multiplePresentationModeViewerTypes && this.multiplePresentationModeViewerTypes.length > 0;
    }

    get currentPresentationSection() {
        return this.$store.state.MeetingsStore.currentPresentationSection.current;
    }

    get sectionForSelectedCourse() {
        if (!this.courseId) {
            return this.currentPresentationSection;
        }
        const courses = this.$store.state.MeetingsStore.currentPresentationSection.perCourse;
        const find = courses.find(entry => entry.courseId === this.courseId);
        return find;
    }

    get isImagesLoading() : boolean {
        return this.$store.state.CourseStore.imagesLoading;
    }

    get isVideoLoading() : boolean {
        return this.$store.state.CourseStore.videoLoading;
    }

    get isSplitVertical() : boolean {
        return this.$store.state.CourseStore.isSplitVertical;
    }

    get zoomObject(): boolean {
        return this.$store.state.CourseStore.zoomObject;
    }

    get isLoadedDocument() : boolean{
        if(!RESIZE_TYPES.includes(this.presentationModeViewerType)){
            return true;
        } else if(this.presentationModeViewerType === SECTION_TYPE_CODES.LESSON_IMAGES){
            return !this.isImagesLoading;
        } else if(this.presentationModeViewerType === SECTION_TYPE_CODES.LESSON_VIDEO){
            return !this.isVideoLoading;
        }
    }

    get userId() : string {
        return btoa(this.$store.state.AuthStore.user.userId);
    }

    get courses(): Course[] {
        return this.$store.state.CourseStore.courses.content;
    }

    get isPresentationModeTeacher(){
        return this.$store.state.CourseStore.isPresentationTeacherMode;
    }

    get encodedToken() : string {
        return btoa(LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT));
    }

    get currentPageInfo () {
        const boardId: number = this.$store.state.MeetingsStore.currentPageSizes[this.documentIndex]?.page;
        return {boardId};
    }

    get whiteboardPath() : string {
        let objectId : number = this.sectionForSelectedCourse?.sectionId || this.sectionForSelectedCourse?.materialId || 0;
        let typeObject : string = this.sectionForSelectedCourse?.materialId ? 'M' : 'S';
        return `${this.initialBoardName}-${typeObject}-${objectId}-${this.documentIndex}-P`;//?lang=${this.$i18n.locale}&transparency=true&userName=${this.userId}&token=${this.encodedToken}`;
    }

    get isWhiteboardTransparency() : boolean {
        return this.$store.state.MeetingsStore.isWhiteboardTransparency;
    }

    get isTransparencyBoardHidden () {
        this.$edEventBus.$emit(COURSE_EVENTS.SEND_TRANSPARENT_WHITEBOARD);
        this.$edEventBus.$emit(SEND_CURRENT_SHARED_TASK_EVENT);

        return !this.isWhiteboardTransparency;
    }

    get initialLoadedBoardsEmited() {
        return this.$store.state.MeetingsStore.initialLoadedBoardsEmited;
    }

    get loadedBoardsInDom() {
        return this.$store.state.MeetingsStore.loadedBoardsInDom;
    }

    get presentationModeScrollInfo() {
        return this.$store.state.MeetingsStore.presentationModeScrollInfo;
    }

    private completeLoadingPages() {
        let currentPage = this.presentationModeScrollInfo.currentPageSizes ? this.presentationModeScrollInfo.currentPageSizes[0].page : this.currentPageInfo.boardId;
        return currentPage <= this.loadedBoardsInDom;
    }

    @Watch('loadedBoardsInDom')
    private verifyBoardsLoadedInDom(){
        this.verifyCompletedLoadingPages();
    }

    private verifyCompletedLoadingPages() {
        if (SKIP_LOADED_PAGE_VERIFICATION_TYPES.includes(this.presentationModeViewerType)) {
            return;
        }
        if(this.initialLoadedBoardsEmited) {
            if(!this.completeLoadingPages()) {
                this.EduacAppSetLoading(true);
            } else {
                this.EduacAppSetLoading(false);
                this.$edEventBus.$emit(BOARD_EVENTS.STUDENT_INITIAL_BOARDS_LOADED, this.presentationModeScrollInfo, true);
            }
        }
    }

    public async loadWhiteboardPath() : Promise<void> {

        if(this.whiteboardPathStored || (this.isPresentationModeTeacher && this.courses.length === 0)){
            return;
        }

        /*let meetingPath : any = await MeetingsService.getSpecificMeetingService(this.meetingId, MEETING_TYPES_VALUES.WHITEBOARD);
        let newWhiteboardPath = `${meetingPath.boardUrl}_transparency`;*/
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_TRANSPARENT_BOARD_PATH, this.initialBoardName);
    }

    public obtainElementContainer() : any {
        if(this.elementContainer){
            return this.elementContainer;
        }

        let classElement = CLASS_ELEMENTS[this.presentationModeViewerType];
        let elementContainer : any = null;

        if(this.documentHash && SELECTOR_QUERY_ELEMENTS[classElement]) {
            elementContainer = document.querySelector(`${SELECTOR_QUERY_ELEMENTS[classElement].replace('documentId', `${this.preId}${this.documentHash}`)}`);
        } else {
            let container : any = document.getElementsByClassName(classElement);
            elementContainer = container.length > 1 ? container[this.documentIndex] : container[0];
        }

        this.elementContainer = elementContainer;
        return elementContainer;
    }

    private resetMenu() : void {
        // this.showMenu = false;
    }

    public onChangeLayout(): void {
        // To be implemented by mixin users
        this.resetMenu();
        this.$nextTick(() => {
            // Pretend the layout change in write object is a zoom, so the boards get properly scaled.
            this.$edEventBus.$emit(BOARD_EVENTS.RESIZE_BOARD, true);
            this.setDocumentContainerHeight();
        });
    }

    public setDocumentContainerHeight() {
        // Each implementation gets called.
    }

    public async loadingPage(pageData: {height: number, width: number, page: number, boardIndex?: number}) : Promise<void> {
        const boardIndex = pageData.boardIndex ? pageData.boardIndex : pageData.page;

        if(this.presentationModeViewerType == SECTION_TYPE_CODES.LESSON_CARD) {
            this.loadedBoardPages = [];
            this.boardPages = [];
            this.boardPage = {};
            pageData.page = 1;
        }

        this.boardPage = {...pageData, boardIndex: boardIndex, boardType: BoardType.Transparency};

        if(this.loadedBoardPages.includes(boardIndex)){
            return;
        }

        this.boardPages = await this.insertAndSort(this.boardPage, this.boardPages);
        this.loadedBoardPages.push(boardIndex);

        this.$nextTick(() => {
            if (this.initializedBoardPages.includes(boardIndex)) {
                this.verifyCompletedLoadingPages();
                this.$edEventBus.$emit(`${BOARD_EVENTS.LOADED_PDF_PAGE}${boardIndex}`,
                    {isTransparency: true});
                this.$edEventBus.$emit(`${this.whiteboardPath}_${boardIndex}${BOARD_EVENTS.CREATE_BOARD}`);
            }
        });
    }


    public insertAndSort(element, array) {
        let positionSorted = this.locationOf(element.page, array, 0, array.length) + 1;
        array.splice(positionSorted, 0, element);
        return array;
    }

    public locationOf(element, array, start, end) {
        start = start || 0;
        end = end || array.length;
        var pivot = parseInt(start + (end - start) / 2, 10);
        if (array[pivot]?.page === element) return pivot;
        if (end - start <= 1)
          return array[pivot]?.page > element ? pivot - 1 : pivot;
        if (array[pivot]?.page < element) {
          return this.locationOf(element, array, pivot, end);
        } else {
          return this.locationOf(element, array, start, pivot);
        }
    }

    private validateStoredPages() : void {
        let originalPagesSize : any[] = this.$store.state.MeetingsStore.originalPagesSize[this.documentHash] ? [...this.$store.state.MeetingsStore.originalPagesSize[this.documentHash]] : [];
        originalPagesSize.forEach(pagesSize => {
            if(!this.loadedBoardPages.includes(pagesSize.page)){
                this.loadingPage(pagesSize);
            }
        });

    }

    protected connect() : void {
        this.createSocketConnection();
        this.socket.on('connect', () => {
            this.validateStoredPages();
            this.showBoard = true;
            this.showMenu = true;
        });
        this.socket.on('removeAllByUser', (message: any) => {
            this.$edEventBus.$emit(`${message.boardName}${BOARD_EVENTS.REMOVE_ELEMENTS}`, message.elementsToDelete);
        });
        this.socket.on('board_annotation_updated', (message: any) => {
            this.$edEventBus.$emit(BOARD_EVENTS.BOARD_ANNOTATIONS_UPDATED);
        });
    }

    public closeLoading() : void {
        this.boardMenu.setCurrentColor();
        this.$edEventBus.$emit(LOADING_EVENTS.HIDE);
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_BOARDS_LOADED_EMITED, true);
    }

    public initBoard(page: number) : void {
        this.initializedBoardPages.push(page);
        if(this.loadedBoardPages.includes(page)){
            this.$edEventBus.$emit(`${BOARD_EVENTS.LOADED_PDF_PAGE}${page}`, {isTransparency: true});
            this.$edEventBus.$emit(`${this.whiteboardPath}_${page}${BOARD_EVENTS.CREATE_BOARD}`);
        }
    }

    public clickPageContainer() {        
        this.$edEventBus.$emit(BOARD_EVENTS.PAGE_CONTAINER_CLICKED);
    }

    @Watch('isWhiteboardTransparency')
    private onIsWhiteboardTransparencyChange(isWhiteboardTransparency : boolean) : void {
        // Emit some event to the event bus that will trigger the enabling / disabling of the board tools
        this.$edEventBus.$emit(BOARD_EVENTS.ENABLE_BOARD_TOOLS, isWhiteboardTransparency);
    }

    onAnnotationConflict(localDocument: WboDocument, conflictingChange: WboVersionedAnnotationData, instance: WboClient) {
        instance?.resolveConflict(ConflictResolutionMethod.Merge);
    }


    mounted() {
        this.$edEventBus.$on(COURSE_EVENTS.SEND_PRESENTATION_LAYOUT, this.onChangeLayout);
        this.initialBoardName = `meeting-${this.meetingId}-transparency`;
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_BOARDS_LOADED_EMITED, false);
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_LOADED_BOARDS_IN_DOM, 0);

        setTimeout(() => {
            this.$edEventBus.$emit(BOARD_EVENTS.STUDENT_INITIAL_BOARDS_LOADED, this.presentationModeScrollInfo, true);
        }, 0);
    }

    beforeDestroy() {
        this.$edEventBus.$off(COURSE_EVENTS.SEND_PRESENTATION_LAYOUT, this.onChangeLayout);
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_BOARDS_LOADED_EMITED, false);
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_LOADED_BOARDS_IN_DOM, 0);
    }
}
